import { cx } from '@/utils/strings'
import { Asset } from 'contentful'
import ImageContentful from './image-contentful'
import Image from '@/components/ui/image'

interface PageBackgroundProps {
  pageBackgroundImage: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>
}

export default function PageBackground({ pageBackgroundImage }: PageBackgroundProps) {
  return (
    <div className="hidden lg:block absolute z-1 top-[-50px] left-0 right-0 w-full [&_svg]:fill-none [&_svg]:w-full [&_figure]:w-full! [&_img]:w-full! [&_svg]:opacity-70">
      <div
        className={cx(
          'after:to-secondary-50 relative max-h-[800px] overflow-hidden after:absolute after:z-1 after:inset-x-0 after:bottom-0 after:md:h-[20%] after:lg:h-[40%] after:bg-gradient-to-b after:from-transparent ',

          'dark:after:to-secondary-900'
        )}
      >
        {pageBackgroundImage.sys?.contentType?.sys?.id === 'resourceImage' ? (
          <ImageContentful
            {...pageBackgroundImage?.fields?.image?.fields}
            darkModeImage={pageBackgroundImage?.fields?.imageDarkMode?.fields}
          />
        ) : (
          <Image image={pageBackgroundImage} />
        )}
      </div>
    </div>
  )
}
